import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../assets/images/tahsilat360_logo2.png";

const NAVY = "#221C5D";

const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString("tr-TR") : "-";

const formatMoney = (amount) => {
  if (amount == null) return "-";
  return (
    new Intl.NumberFormat("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount) + " ₺"
  );
};

const statusLabel = (status) => {
  const map = {
    ACTIVE: "Aktif",
    TRIAL: "Deneme",
    PENDING: "Odeme Bekliyor",
    EXPIRED: "Suresi Dolmus",
    CANCELLED: "Iptal",
    UPGRADED: "Yukseltilmis",
  };
  return map[status] || status;
};

/**
 * @param {Object} sub - subscription object with:
 *   id, planName, startDate, endDate, paidAmount, vatAmount,
 *   couponCode, couponDiscount, status, createdAt,
 *   invoiceCompanyName, invoiceTaxNumber, invoiceTcNumber,
 *   invoiceTaxOffice, invoiceAddress, companyName
 */
const createInvoiceHtml = (sub) => {
  const faturaNo = (sub.id || "").substring(0, 8).toUpperCase();
  const faturaTarihi = formatDate(sub.createdAt || sub.startDate);

  const paidAmount = Number(sub.paidAmount) || 0;
  const vatAmount = Number(sub.vatAmount) || 0;
  const couponDiscount = Number(sub.couponDiscount) || 0;
  const subtotal = paidAmount + couponDiscount;

  const hasInvoiceInfo =
    sub.invoiceCompanyName ||
    sub.invoiceTaxNumber ||
    sub.invoiceTcNumber ||
    sub.invoiceTaxOffice ||
    sub.invoiceAddress;

  const invoiceInfoHtml = hasInvoiceInfo
    ? `
    <div style="margin-bottom: 24px;">
      <h3 style="color: ${NAVY}; border-bottom: 2px solid ${NAVY}; padding-bottom: 6px; margin-bottom: 12px; font-size: 15px;">Fatura Bilgileri</h3>
      <div style="background: #f8f9fa; padding: 14px 16px; border-radius: 10px; border: 1px solid #eee;">
        ${sub.invoiceCompanyName ? `<p style="margin: 5px 0;"><strong>Unvan:</strong> ${sub.invoiceCompanyName}</p>` : ""}
        ${sub.invoiceTaxNumber ? `<p style="margin: 5px 0;"><strong>Vergi No:</strong> ${sub.invoiceTaxNumber}</p>` : ""}
        ${sub.invoiceTcNumber ? `<p style="margin: 5px 0;"><strong>TC Kimlik No:</strong> ${sub.invoiceTcNumber}</p>` : ""}
        ${sub.invoiceTaxOffice ? `<p style="margin: 5px 0;"><strong>Vergi Dairesi:</strong> ${sub.invoiceTaxOffice}</p>` : ""}
        ${sub.invoiceAddress ? `<p style="margin: 5px 0;"><strong>Adres:</strong> ${sub.invoiceAddress}</p>` : ""}
      </div>
    </div>
  `
    : "";

  return `
    <div style="font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto; background: white; padding: 24px;">

      <!-- HEADER -->
      <div style="text-align: center; margin-bottom: 24px; border-bottom: 3px solid ${NAVY}; padding-bottom: 16px;">
        <img src="${logo}" alt="Tahsilat360" style="max-height: 80px; max-width: 250px; margin-bottom: 8px;" />
        <h2 style="color: #333; margin: 6px 0 0 0; font-size: 22px; letter-spacing: 1px;">ABONELIK FATURASI</h2>
      </div>

      <!-- INFO GRID -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 24px;">

        <!-- Left: Fatura Ozeti -->
        <div>
          <h3 style="color: ${NAVY}; border-bottom: 2px solid ${NAVY}; padding-bottom: 6px; margin-bottom: 12px; font-size: 15px;">Fatura Ozeti</h3>
          <div style="background: #f8f9fa; padding: 14px 16px; border-radius: 10px; border: 1px solid #eee;">
            <p style="margin: 5px 0;"><strong>Fatura No:</strong> <code style="background:#e9ecef;padding:2px 6px;border-radius:4px;font-size:13px;">${faturaNo}</code></p>
            <p style="margin: 5px 0;"><strong>Tarih:</strong> ${faturaTarihi}</p>
            <p style="margin: 5px 0;"><strong>Durum:</strong> <span style="color: ${sub.status === "ACTIVE" ? "#28a745" : NAVY}; font-weight: 600;">${statusLabel(sub.status)}</span></p>
            ${sub.companyName ? `<p style="margin: 5px 0;"><strong>Firma:</strong> ${sub.companyName}</p>` : ""}
          </div>
        </div>

        <!-- Right: Plan Detaylari -->
        <div>
          <h3 style="color: ${NAVY}; border-bottom: 2px solid ${NAVY}; padding-bottom: 6px; margin-bottom: 12px; font-size: 15px;">Paket Detaylari</h3>
          <div style="background: #f8f9fa; padding: 14px 16px; border-radius: 10px; border: 1px solid #eee;">
            <p style="margin: 5px 0;"><strong>Paket:</strong> <span style="color: ${NAVY}; font-weight: 700;">${sub.planName || "-"}</span></p>
            <p style="margin: 5px 0;"><strong>Baslangic:</strong> ${formatDate(sub.startDate)}</p>
            <p style="margin: 5px 0;"><strong>Bitis:</strong> ${formatDate(sub.endDate)}</p>
            ${sub.couponCode ? `<p style="margin: 5px 0;"><strong>Kupon:</strong> <code style="background:#e9ecef;padding:2px 6px;border-radius:4px;font-size:13px;">${sub.couponCode}</code></p>` : ""}
          </div>
        </div>
      </div>

      ${invoiceInfoHtml}

      <!-- ODEME DETAYLARI -->
      <div style="margin-bottom: 24px;">
        <h3 style="color: ${NAVY}; border-bottom: 2px solid ${NAVY}; padding-bottom: 6px; margin-bottom: 12px; font-size: 15px;">Odeme Detaylari</h3>
        <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
          <tr style="border-bottom: 1px solid #eee;">
            <td style="padding: 10px 12px; color: #555;">Ara Toplam</td>
            <td style="padding: 10px 12px; text-align: right; font-weight: 600;">${formatMoney(subtotal)}</td>
          </tr>
          <tr style="border-bottom: 1px solid #eee;">
            <td style="padding: 10px 12px; color: #555;">KDV</td>
            <td style="padding: 10px 12px; text-align: right; font-weight: 600;">${formatMoney(vatAmount)}</td>
          </tr>
          ${
            couponDiscount > 0
              ? `<tr style="border-bottom: 1px solid #eee;">
                   <td style="padding: 10px 12px; color: #555;">Kupon Indirimi</td>
                   <td style="padding: 10px 12px; text-align: right; font-weight: 600; color: #28a745;">-${formatMoney(couponDiscount)}</td>
                 </tr>`
              : ""
          }
          <tr style="background: ${NAVY}; color: #fff; border-radius: 8px;">
            <td style="padding: 12px 14px; font-weight: 700; font-size: 16px; border-radius: 0 0 0 8px;">TOPLAM</td>
            <td style="padding: 12px 14px; text-align: right; font-weight: 700; font-size: 18px; border-radius: 0 0 8px 0;">${formatMoney(paidAmount)}</td>
          </tr>
        </table>
      </div>

      <!-- FOOTER -->
      <div style="text-align: center; margin-top: 40px; padding-top: 14px; border-top: 1px solid #dee2e6; color: #888; font-size: 11px;">
        <p style="margin: 4px 0;">Bu belge sistem uzerinden otomatik olarak olusturulmustur.</p>
        <p style="margin: 4px 0;">Tahsilat360 &copy; ${new Date().getFullYear()} - Guvenli Tahsilat Sistemi</p>
        <p style="margin: 4px 0; color: #aaa;">Olusturulma Tarihi: ${new Date().toLocaleString("tr-TR")}</p>
      </div>
    </div>
  `;
};

/**
 * Abonelik faturasi PDF olusturur ve indirir.
 * @param {Object} sub - subscription nesnesi
 */
export const downloadSubscriptionInvoicePdf = async (sub) => {
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.left = "-9999px";
  container.style.top = "0";
  container.style.width = "800px";
  container.style.background = "white";
  container.innerHTML = createInvoiceHtml(sub);
  document.body.appendChild(container);

  try {
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position = -(imgHeight - heightLeft);
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    const faturaNo = (sub.id || "").substring(0, 8).toUpperCase();
    pdf.save(`abonelik-fatura-${faturaNo}.pdf`);
  } finally {
    document.body.removeChild(container);
  }
};
